<div *ngIf="videoEnabled" class="player-holder">
    <app-nano-player [config]="config"></app-nano-player>
</div>

<button i18n class="button button-max-width" (click)="toggleClicked.emit()">
    @if (videoEnabled) {
        Hide video
    } @else {
        Show video
    }
</button>
